// src/components/Leadership/PerformanceMeasurement.js
import React from 'react';
import { BarChart3, Shield, TrendingUp, Calendar } from 'lucide-react';
import '../../styles/Leadership/PerformanceMeasurement.css';

const PerformanceMeasurement = () => {
  const metrics = [
    {
      icon: "📊",
      title: "KPIs",
      subtitle: "Key Performance Indicators",
      description: "Transparent metrics tied to business outcomes.",
      details: [
        "Revenue impact tracking",
        "User engagement metrics",
        "System performance indicators",
        "Team velocity measurements"
      ],
      color: "#3b82f6"
    },
    {
      icon: "📑",
      title: "SLAs",
      subtitle: "Service Level Agreements",
      description: "Guaranteed ownership of your systems—uptime, response, and business continuity commitments.",
      details: [
        "99.9% uptime—end-to-end ownership",
        "< 15min incident response",
        "< 4hr critical issue resolution",
        "Monthly SLA reporting"
      ],
      color: "#0d9488"
    },
    {
      icon: "🔄",
      title: "PI",
      subtitle: "Performance Indicators",
      description: "Continuous improvement cycles aligned with organizational goals.",
      details: [
        "Sprint velocity tracking",
        "Code quality metrics",
        "Deployment frequency",
        "Mean time to recovery"
      ],
      color: "#8b5cf6"
    },
    {
      icon: "📅",
      title: "WSR & MSR Reports",
      subtitle: "Weekly & Monthly Status",
      description: "Reporting frameworks that keep leadership informed and accountable.",
      details: [
        "Weekly status reports (WSR)",
        "Monthly summary reports (MSR)",
        "Executive dashboards",
        "Risk & blocker visibility"
      ],
      color: "#f59e0b"
    }
  ];

  return (
    <section className="performance-measurement">
      <div className="performance-container">
        <div className="section-header-center">
          <span className="section-badge">Performance & Measurement</span>
          <h2 className="section-title">
            We don't just deliver code—we deliver results.
          </h2>
          <p className="section-description">
            Every engagement is backed by transparent metrics, guaranteed service levels, 
            and continuous reporting that keeps stakeholders informed.
          </p>
        </div>

        <div className="metrics-grid">
          {metrics.map((metric, index) => (
            <div key={index} className="metric-card">
              <div className="metric-header">
                <div className="metric-icon-large" style={{ borderColor: metric.color }}>
                  {metric.icon}
                </div>
                <div className="metric-header-text">
                  <h3 className="metric-title">{metric.title}</h3>
                  <p className="metric-subtitle">{metric.subtitle}</p>
                </div>
              </div>

              <p className="metric-description">{metric.description}</p>

              <div className="metric-details">
                {metric.details.map((detail, idx) => (
                  <div key={idx} className="metric-detail-item">
                    <div className="detail-indicator" style={{ background: metric.color }}></div>
                    <span>{detail}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Results Statement */}
        <div className="results-statement">
          <div className="results-icon-section">
            <BarChart3 className="results-icon" />
          </div>
          <div className="results-content">
            <h3 className="results-title">Outcome-Driven Development</h3>
            <p className="results-text">
              Traditional agencies deliver features. We deliver measurable business impact. 
              Every line of code, every sprint, every release is tied to KPIs that matter to 
              your board and stakeholders. You'll always know exactly what you're getting, 
              when you're getting it, and how it impacts your bottom line.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerformanceMeasurement;